<template>
  <v-card class="pa-4">
    <v-flex xs12 pb-4 v-if="err">
      <v-alert :value="true" type="error">{{err}}</v-alert>
    </v-flex>
    <v-flex xs12 pb-4 v-if="success">
      <v-alert :value="true" type="success">{{success}}</v-alert>
    </v-flex>
    <p>{{$lang.labels.catalogActivationText}}</p>
    <v-checkbox
      :key="index"
      v-model="moon.activate"
      hide-details
      color="primary"
      :error="moon.error"
      :success="moon.success"
      :label="$lang.labels.moon"
    />
    <v-layout column>
      <template v-for="(webshop, index) in webshops">
        <v-checkbox
          :key="index"
          v-model="selectedWebshops"
          hide-details
          color="primary"
          :error="webshop.error"
          :success="webshop.success"
          :value="webshop.id"
          :label="`${$lang.labels.webshop} - ${webshop.name}`"
        />
      </template>
    </v-layout>
    <v-layout row wrap justify-space-between>
      <v-btn flat @click="$emit('close')" class="mx-0">{{$lang.actions.no}}</v-btn>
      <v-btn color="primary" @click="activate()" class="mx-0">{{$lang.actions.yes}}</v-btn>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    props: ['data'],
    data: () => ({
      err: '',
      success: '',
      selectedWebshops: [],
      isLocalAdmin: false,
      moon: {
        activate: true,
        error: false,
        success: false,
      },
      webshops: [],
    }),
    methods: {
      activate() {
        const actions = [];
        let hasErrors = false;
        if (this.moon.activate) {
          actions.push(new Promise((resolve) => {
            this.$http.post(`catalog/activate/${this.data.catalogId}`, {})
              .then((res) => {
                if (res.body.status !== 'Success') {
                  this.moon.error = true;
                  hasErrors = true;
                  resolve();
                  return;
                }
                this.moon.error = false;
                this.moon.activate = false;
                this.moon.success = true;
                resolve();
              })
              .catch((e) => {
                this.moon.error = true;
                hasErrors = true;
                resolve();
              });
          }));
        }
        const webshopSuccess = [];
        if (this.selectedWebshops.length > 0) {
          actions.push(...this.webshops
            .filter((webshop) => this.selectedWebshops.includes(webshop.id))
            .map(webshop => new Promise((resolve) => {
              this.$http.post(
                `webshopresource/catalog/switchversionandview/${webshop.id}`,
                {
                  catalogViewId: this.data.catalogViewId,
                  catalogVersion: this.data.catalogVersion,
                }
              )
                .then((res) => {
                  if (res.body.status !== 'Success') {
                    this.$set(webshop, 'error', true);
                    hasErrors = true;
                    resolve();
                    return;
                  }
                  this.$set(webshop, 'error', false);
                  this.$set(webshop, 'success', true);
                  webshopSuccess.push(webshop.id);
                  resolve();
                })
                .catch((e) => {
                  this.$set(webshop, 'error', true);
                  hasErrors = true;
                  resolve();
                });
            }))
          );

          // this.webshops.forEach((webshop) => {
          //   if (this.selectedWebshops.includes(webshop.id)) {
          //     actions.push();
          //   }
          // });
        }
        Promise.all(actions).then(() => {
          if (hasErrors) {
            this.err = 'Failed to activate on all resources';
            // if (this.isLocalAdmin) return;
            this.selectedWebshops = this.selectedWebshops.filter(current => !webshopSuccess.includes(current.id));
            return;
          }
          this.$emit('close', this.moon.success);
        });
      },
      generateWebshopData(webshop) {
        const data = {
          name: webshop.name,
          planetInstanceId: webshop.planetInstanceId,
          email: webshop.email,
          subscriptionModel: webshop.subscriptionModel,
          catalogViewId: this.data.catalogViewId,
          catalogVersion: this.data.catalogVersion,
          paymentTypes: webshop.paymentTypes,
          orderTypes: webshop.orderTypes,
          sendToMoon: webshop.sendToMoon,
          minDeliveryAmount: webshop.minDeliveryAmount,
          rules: webshop.rules,
          confirmationEmailPrefix: webshop.confirmationEmailSettingsDetails ? (webshop.confirmationEmailSettingsDetails.prefix || null) : null,
          confirmationEmailPostFix: webshop.confirmationEmailSettingsDetails ? (webshop.confirmationEmailSettingsDetails.postfix || null) : null,
          bccEmail: webshop.confirmationEmailSettingsDetails ? (webshop.confirmationEmailSettingsDetails.bccEmail || null) : null,
          orderSubmissionAllowedFrom: webshop.orderSubmissionAllowedFrom,
          deliveryDurationFrom: webshop.deliveryDurationFrom,
          deliveryDurationTo: webshop.deliveryDurationTo,
        };
        if (webshop.paymentGatewaySettingDetails) {
          data.paymentGateway = webshop.paymentGatewaySettingDetails.paymentGateway;
          if (data.paymentGateway === 'paymentsense') {
            data.merchantId = webshop.paymentGatewaySettingDetails.merchantId;
            data.preSharedKey = webshop.paymentGatewaySettingDetails.preSharedKey;
          }
        }
        return data;
      },
    },
    created() {
      this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
      // if (this.isLocalAdmin) return;
      if (this.data.webshops) {
        this.webshops = this.data.webshops.map(webshop => ({ ...webshop, error: false, success: false }));
        this.webshops.forEach(webshop => this.selectedWebshops.push(webshop.id));
      // {
      //   catalogId: data.catalogId,
      //   companyId: this.selectedCompany.id,
      //   webshops
      // }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CatalogActivationModal.vue?1d9da1c5